module.exports = __webpack_public_path__ + "static/318133460_666023861860719_1546111661104788293_n.jpg-1671186393566-792ff8e3f2d6e91cc9dab2a28320011b.webp";